
<div class="container register-container">
  <div class="row row-1">
    <div class="col-sm-7 col-1">
      <h2 class="overview-header register-header">Register</h2>
    </div>
    <div class="col-sm-5 col-2">
    </div>
  </div>

  <div class="card" style="">
    <div class="card-header bp-card-header">
      <!-- Steps form -->
      <div class="card">
        <div class="card-body mb-4">
          <!-- Stepper -->
          <div class="steps-form">
            <div class="steps-row setup-panel">
              <div class="steps-step step-1">
                <a href="#step-9" type="button" class="btn btn-indigo btn-circle">1</a>
                <p class="bp-text">Find Account</p>
              </div>
              <div class="steps-step step-2">
                <a href="#step-10" type="button" class="btn btn-indigo btn-circle" disabled="disabled">2</a>
                <p class="bp-text">About You</p>
              </div>
              <div class="steps-step step-3">
                <a href="#step-11" type="button" class="btn btn-indigo btn-circle" disabled="disabled">3</a>
                <p class="bp-text">Set Password</p>
              </div>
            </div>
          </div>

          <form role="form" action="" method="post">

            <!-- First Step -->
            <div class="row setup-content" id="step-9">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Second Step -->
            <div class="row setup-content" id="step-10">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Third Step -->
            <div class="row setup-content" id="step-11">
              <div class="col-md-12">
              </div>
            </div>

          </form>

        </div>
      </div>
      <!-- Steps form -->
    </div>
    <div class="card-body" style="margin-bottom: 3%;">
      <div class="row register-row bp-text bp-small-text" style="margin-top: 1.5%;margin-bottom: .3%;">
        <p class="color: #777;">We're nearly done!</p>
        <p class="color: #777;">Please create a username and password and agree to the Terms of Service.</p>
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="userExists">
        <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
        <span>User already exists, please log in.</span>
      </div>
      <div class="row register-row">
        <div class="col-sm-6">
          <form #registrationSetPasswordForm="ngForm">
            <div class="form-group bill-info-form-group">

              <label for="txtSetUsername" class="bp-text login-label bp-small-text">Username</label>
              <input #txtSetUsername="ngModel" [(ngModel)]="customer.username" name="txtSetUsername" required type="text" class="form-control form-input-6" id="txtSetUsername">
              <div [hidden]="txtSetUsername.valid || txtSetUsername.pristine" class="alert alert-danger register-alert-6">Please enter a Username</div>

              <label for="txtSetPassword" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Password (Case-Sensitive)</label>
              <input #txtSetPassword="ngModel" [(ngModel)]="customer.password" name="txtSetPassword" required type="password" class="form-control form-input-6" id="txtSetPassword">
              <div [hidden]="txtSetPassword.valid || txtSetPassword.pristine" class="alert alert-danger register-alert-6">Please enter Password</div>

              <label for="txtRetypePassword" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Retype Password</label>
              <input #txtRetypePassword="ngModel" [(ngModel)]="retypePassword" name="txtRetypePassword" required type="password" class="form-control form-input-6" id="txtRetypePassword">
              <div [hidden]="txtRetypePassword.valid || txtRetypePassword.pristine" class="alert alert-danger register-alert-6">Please retype Password</div>

            </div>
            <div class="form-group form-check">
              <input #chkbxTerms="ngModel" [(ngModel)]="termsAccepted" name="chkbxTerms" required style="margin-right: 1%;" type="checkbox" class="form-check-input" id="chkbxTerms">
              <label class="form-check-label" for="chkbxTerms">I accept the <a target="_blank" routerLink="/TermsOfService">Terms of Service</a></label>
              <div [hidden]="chkbxTerms.valid || chkbxTerms.pristine" class="alert alert-danger register-alert-6">Please accept Terms of Service</div>
            </div>
            <div class="form-group">
              <button style="width: 17%;" type="submit" [disabled]="!registrationSetPasswordForm.form.valid || submitting" class="btn btn-primary bp-text" (click)="onSubmitClick()">Submit</button>
              <span><a class="bp-link-blue" (click)="onBack()">BACK</a></span>
              <span><a class="bp-link-blue" (click)="onCancel()">CANCEL</a></span>
            </div>
          </form>
        </div>
      </div>
      <footer class="blockquote-footer water-usage-footer"></footer>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/set-pass/set-pass.component.html